<div *ngIf="responses" class="trainers">
    <div class="column">
        <table *ngIf="responses.length > 0" class="table table-striped">
            <thead>
                <tr>
                    <th>
                        {{ 'staffing-result.table-header.trainer' | translate }}
                    </th>
                    <th>
                        {{ 'staffing-result.table-header.company' | translate }}
                    </th>
                    <th>
                        {{
                            'staffing-result.table-header.answer-title'
                                | translate
                        }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let response of responses">
                    <td>
                        {{ trainers[response.trainerId].trainer.firstName }}
                        {{ trainers[response.trainerId].trainer.lastName }}
                    </td>
                    <td>
                        {{ trainers[response.trainerId].trainer.companyName }}
                    </td>
                    <td class="answer">
                        <staffing-result-answer
                            [answer]="response.answer"
                        ></staffing-result-answer>
                    </td>
                    <td class="send-mail">
                        <button
                            class="btn btn-default"
                            (click)="sendMail(response.trainerId)"
                        >
                            <i class="fa fa-envelope-o" aria-hidden="true"></i>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
        <div style="padding: 15px;" *ngIf="responses.length === 0">
            {{ 'staffing-result.not-send-yet' | translate }}
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// ./src/app/_screens/_shared/staffing/result/staffing-result.component.html